import React from "react";
import { Route, Switch } from "react-router";
import AuthRoute from "../auth/components/routes/AuthRoute";
import { EducationType } from "../school/constants/types";
import { UserRole } from "../user/enums/UserRole";
import NotFound from "../pages/NotFound";
import AcademicsPageSecondary from "./pages/AcademicsPageSecondary";
import AcademicsPageHigher from "./pages/AcademicsPageHigher";
import { useSchoolType } from "../school/hooks/useSchoolType";

export function AcademicsRoutes({ path }: { path: string }) {
  const schoolType = useSchoolType();

  const getAcademicsPage = (type) => {
    switch (type) {
      case EducationType.Higher:
        return AcademicsPageHigher;
      case EducationType.Secondary:
        return AcademicsPageSecondary;
      default:
        return NotFound;
    }
  };

  return (
    <Route path={path}>
      <Switch>
        <AuthRoute
          exact
          path={path}
          roles={[UserRole.School]}
          component={getAcademicsPage(schoolType)}
        />
        <Route path={`${path}/*`} component={NotFound} />
      </Switch>
    </Route>
  );
}
